import type {
  ISearchGenreOrTag,
  ISearchPerson,
  ISearchSeries,
} from "./searchPage.types";
import type { ArtShortSerializer } from "../generated/foundation/api";

export enum ZeroSearchResponseItemTypesEnum {
  arts = "art_slider",
  persons = "person_list",
  tags = "tag_list",
  series = "series_list",
}

export interface IZeroSearchPageState {
  recommendationBlocks: IZeroSearchBlock[];
  loading: boolean;
  error?: Record<string, unknown>;
  isListInitiated: boolean;
  isInfoInitiated: boolean;
  data: Record<ZeroSearchResponseItemTypesEnum, IZeroSearchBlockContent>;
}

interface IZeroSearchBlockContent {
  data: ZeroSearchAllItem[];
  pagination: {
    next_page: string | null;
    previous_page: string | null;
  };
  loading: boolean;
}

export interface IZeroSearchBlock {
  type: ZeroSearchResponseItemTypesEnum;
  content_url: string;
  title: string;
  name: string;
}

export interface IZeroSearchResponse {
  error?: any;
  status: number;
  payload: {
    data: IZeroSearchBlock[];
  };
}

// типы для запроса о содержимом блоков
export interface IZeroSearchBlockRequest {
  url: string;
  type: ZeroSearchResponseItemTypesEnum;
}

export interface IZeroSearchBlockResponse {
  error?: any;
  status: number;
  payload: {
    data: ZeroSearchAllItem[];
    pagination: {
      next_page: string | null;
      previous_page: string | null;
    };
  };
}

export interface IActionMeta {
  arg: {
    type:
      | ZeroSearchResponseItemTypesEnum.arts
      | ZeroSearchResponseItemTypesEnum.persons
      | ZeroSearchResponseItemTypesEnum.series
      | ZeroSearchResponseItemTypesEnum.tags;
  };
  requestId: string;
  requestStatus: string;
}

export type ZeroSearchAllItem =
  | ISearchPerson
  | ArtShortSerializer
  | ISearchSeries
  | ISearchGenreOrTag;
